export const CONVERSATION_PARTICIPANT_STATUS = {
  INBOX: 'inbox',
  ARCHIVED: 'archived',
} as const;

export type ConversationParticipantStatus =
  (typeof CONVERSATION_PARTICIPANT_STATUS)[keyof typeof CONVERSATION_PARTICIPANT_STATUS];
